/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import {
  dlsColorNeutral,
  dlsColorSuccess,
  dlsColorWarning,
  IconDeclined, // eslint-disable-line no-unused-vars
  IconInfo, // eslint-disable-line no-unused-vars
  IconSuccess, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';
import { FxJourneyCompletionPage } from 'axp-fx-common'; // eslint-disable-line no-unused-vars

const RegistrationErrorPage = ({ errorData }) => {
  const { status, errorMessage, additionalMessage } = errorData;

  const renderIcon = () => {
    switch (status) {
      case 'success':
        return <IconSuccess size="lg" theme={dlsColorSuccess} />;
      case 'failed':
        return <IconDeclined size="lg" theme={dlsColorWarning} />;
      case 'info':
        return <IconInfo size="lg" theme={dlsColorNeutral} />;
      default:
        return null;
    }
  };

  return (
    <div
      className="flex flex-column flex-justify-center"
      css={{ height: '80%' }}
    >
      <FxJourneyCompletionPage
        icon={renderIcon()}
        status={status}
        heading={errorMessage}
        details={additionalMessage}
      />
    </div>
  );
};

RegistrationErrorPage.propTypes = {
  errorData: PropTypes.shape({
    status: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    additionalMessage: PropTypes.string,
  }).isRequired,
};

export default RegistrationErrorPage;
